module.exports = __webpack_public_path__ + "static/media/avatar_38.2349910b.svg";